/* PokeVault: fjerner den hvide baggrund på produktbilleder i browseren, så de står på mint i ægte farver.
   1) Almindelig udskæring fra billedets kant.
   2) Er produktet selv hvidt med mønster (fx 151), bruges en udskæring der kun følger store, rene hvide flader.
   3) Billeder i TRIM-listen får kun fjernet helt hvide kanter (kasser der fylder billedet). */
(function () {
  document.documentElement.classList.add('pv-cut-on');
  var SEL = 'img.pv-cutout, .card-gallery img, .product-media-container img, .collection-card__image img';
  var TRIM = ['502004_in_1000x1000'];
  var cache = {};

  function ready(img) { img.classList.add('pv-cutout--ready'); }

  function softEdges(p, w, h) {
    var n = w * h;
    for (var k = 0; k < n; k++) {
      var o = k * 4;
      if (p[o + 3] === 0) continue;
      var m = Math.min(p[o], p[o + 1], p[o + 2]);
      if (m <= 190) continue;
      var cx = k % w;
      var nb = (cx > 0 && p[(k - 1) * 4 + 3] === 0) || (cx < w - 1 && p[(k + 1) * 4 + 3] === 0) ||
               (k >= w && p[(k - w) * 4 + 3] === 0) || (k < n - w && p[(k + w) * 4 + 3] === 0);
      if (nb) p[o + 3] = Math.max(0, Math.min(255, Math.round(255 * (255 - m) / 65)));
    }
  }

  function edgeCount(p, w, h) {
    var n = w * h, e = 0;
    for (var k = 0; k < n; k++) {
      if (p[k * 4 + 3] !== 0) continue;
      var cx = k % w;
      if ((cx > 0 && p[(k - 1) * 4 + 3] !== 0) || (cx < w - 1 && p[(k + 1) * 4 + 3] !== 0) ||
          (k >= w && p[(k - w) * 4 + 3] !== 0) || (k < n - w && p[(k + w) * 4 + 3] !== 0)) e++;
    }
    return e;
  }

  function simple(p, w, h) {
    var n = w * h, seen = new Uint8Array(n), st = [], i, k, removed = 0;
    function light(k) { var o = k * 4; return p[o] > 228 && p[o + 1] > 228 && p[o + 2] > 228; }
    for (i = 0; i < w; i++) { st.push(i, (h - 1) * w + i); }
    for (i = 0; i < h; i++) { st.push(i * w, i * w + w - 1); }
    while (st.length) {
      k = st.pop();
      if (seen[k]) continue;
      seen[k] = 1;
      if (!light(k)) continue;
      p[k * 4 + 3] = 0; removed++;
      var cx = k % w;
      if (cx > 0) st.push(k - 1);
      if (cx < w - 1) st.push(k + 1);
      if (k >= w) st.push(k - w);
      if (k < n - w) st.push(k + w);
    }
    return removed;
  }

  function solid(p, w, h) {
    var n = w * h, T = 238, k, x, y, i;
    var L = new Uint8Array(n);
    for (k = 0; k < n; k++) { var o = k * 4; L[k] = (p[o] > T && p[o + 1] > T && p[o + 2] > T) ? 1 : 0; }
    var r = Math.max(4, Math.round(Math.max(w, h) * 0.012));
    var W = w + 1, I = new Int32Array(W * (h + 1));
    for (y = 0; y < h; y++) { var row = 0; for (x = 0; x < w; x++) { row += L[y * w + x] ? 0 : 1; I[(y + 1) * W + x + 1] = I[y * W + x + 1] + row; } }
    function box(A, x0, y0, x1, y1) { x0 = Math.max(0, x0); y0 = Math.max(0, y0); x1 = Math.min(w - 1, x1); y1 = Math.min(h - 1, y1); return A[(y1 + 1) * W + x1 + 1] - A[y0 * W + x1 + 1] - A[(y1 + 1) * W + x0] + A[y0 * W + x0]; }
    var S = new Uint8Array(n);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) { k = y * w + x; if (L[k] && box(I, x - r, y - r, x + r, y + r) === 0) S[k] = 1; }
    var R = new Uint8Array(n), seen = new Uint8Array(n), st = [];
    for (i = 0; i < w; i++) { st.push(i, (h - 1) * w + i); }
    for (i = 0; i < h; i++) { st.push(i * w, i * w + w - 1); }
    while (st.length) {
      k = st.pop();
      if (seen[k]) continue;
      seen[k] = 1;
      if (!S[k]) continue;
      R[k] = 1;
      var cx = k % w;
      if (cx > 0) st.push(k - 1);
      if (cx < w - 1) st.push(k + 1);
      if (k >= w) st.push(k - w);
      if (k < n - w) st.push(k + w);
    }
    var J = new Int32Array(W * (h + 1));
    for (y = 0; y < h; y++) { var row2 = 0; for (x = 0; x < w; x++) { row2 += R[y * w + x]; J[(y + 1) * W + x + 1] = J[y * W + x + 1] + row2; } }
    var removed = 0;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) { k = y * w + x; if (R[k] || (L[k] && box(J, x - r, y - r, x + r, y + r) > 0)) { p[k * 4 + 3] = 0; removed++; } }
    return removed;
  }

  function trim(p, w, h) {
    function light(k) { var o = k * 4; return p[o] > 226 && p[o + 1] > 226 && p[o + 2] > 226; }
    function col(cx) { var l = 0; for (var y = 0; y < h; y++) if (light(y * w + cx)) l++; return l / h; }
    function row(cy) { var l = 0; for (var x = 0; x < w; x++) if (light(cy * w + x)) l++; return l / w; }
    var L = 0; while (L < w / 3 && col(L) > 0.985) L++;
    var R = w - 1; while (R > w * 2 / 3 && col(R) > 0.985) R--;
    var T = 0; while (T < h / 3 && row(T) > 0.985) T++;
    var B = h - 1; while (B > h * 2 / 3 && row(B) > 0.985) B--;
    var removed = 0;
    for (var k = 0; k < w * h; k++) { var cx = k % w, cy = (k - cx) / w; if (cx < L || cx > R || cy < T || cy > B) { p[k * 4 + 3] = 0; removed++; } }
    return removed;
  }

  function cut(im, src) {
    var w = im.naturalWidth, h = im.naturalHeight;
    if (!w || !h) return null;
    var s = Math.min(1, 1200 / Math.max(w, h));
    w = Math.round(w * s); h = Math.round(h * s);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h);
    var orig = new Uint8ClampedArray(d.data);
    var p = d.data;

    if (TRIM.some(function (t) { return src.indexOf(t) !== -1; })) {
      if (!trim(p, w, h)) return 'skip';
      x.putImageData(d, 0, 0); return c;
    }

    if (!simple(p, w, h)) return 'skip';
    if (edgeCount(p, w, h) > 5 * (w + h)) {
      p.set(orig);
      if (!solid(p, w, h)) return 'skip';
      if (edgeCount(p, w, h) > 5 * (w + h)) return 'skip';
    }
    softEdges(p, w, h);
    x.putImageData(d, 0, 0);
    return c;
  }

  function process(src, cb) {
    var e = cache[src];
    if (e) { if (e.done) cb(e.url); else e.q.push(cb); return; }
    e = cache[src] = { q: [cb], done: false, url: null };
    function finish(u) { e.done = true; e.url = u; var q = e.q; e.q = []; q.forEach(function (f) { f(u); }); }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var out = null;
      try { out = cut(im, src); } catch (err) { out = null; }
      if (!out || out === 'skip') return finish(null);
      out.toBlob(function (b) { finish(b ? URL.createObjectURL(b) : null); }, 'image/png');
    };
    im.onerror = function () { finish(null); };
    im.src = src;
  }

  function handle(img) {
    if (img.dataset.pvCut) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('blob:') === 0 || src.indexOf('data:') === 0) return ready(img);
    img.dataset.pvCut = '1';
    var t = setTimeout(function () { ready(img); }, 4000);
    process(src, function (u) {
      if (!u) { clearTimeout(t); return ready(img); }
      img.addEventListener('load', function () { clearTimeout(t); ready(img); }, { once: true });
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = u;
    });
  }

  function watch(img) {
    if (img.dataset.pvWatch) return;
    img.dataset.pvWatch = '1';
    if (img.complete && img.naturalWidth) handle(img);
    else {
      img.addEventListener('load', function () { handle(img); }, { once: true });
      img.addEventListener('error', function () { ready(img); }, { once: true });
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SEL)) watch(root);
    root.querySelectorAll(SEL).forEach(watch);
  }

  function init() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (nd) { if (nd.nodeType === 1) scan(nd); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
